import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { StyleOne, StyleTwo } from '../components/RelatedSCard';
import Jobs from '../data/services.json';
import Not from '../components/NotFound'
import renderHTML from 'react-render-html'
import {CardTwoOutine} from '../components/contentCards/cardTwo';
import asset from '../assets/images/IMG_0421.JPG'
import { Nav, NavItem, NavLink as ReactStrapNavLink } from 'reactstrap';
import { Collapse, Button, CardBody, Card } from 'reactstrap';


class ProductList extends Component {


    state = {
        // bucket: [],
        Jobs: {
            Jobs: []
        },
        link: this.props.match.params.tabview, //"gMarkets",
        collapse: true,
        collapseTwo: true
    }


    toggle = () => {
          this.setState({ collapse: !this.state.collapse });
          document.getElementById('faInd').classList.toggle('rotateFAOpen');
        //   document.getElementById('hrInd').classList.toggle('d-none');
    }

    toggleTwo = () => {
        this.setState({ collapseTwo: !this.state.collapseTwo });
        document.getElementById('faIns').classList.toggle('rotateFAOpen');
        // document.getElementById('hrIns').classList.toggle('d-none');
    }


    setActive = (value) => {
        this.setState({ link: value })
      }


    componentDidMount() {
        this.setState({ Jobs })
    }

    render() {
        // Our clients benefit because we understand their opportunities and challenges. As part of the FDSH group, we have access to a diverse portfolio of forward-thinking products to help make your financial dreams a reality.
        const { link} = this.state;
        let headText = "";
        let headTitle = "";
        if (link === "gMarkets"){
          headTitle = 'Global Markets';
          headText = "Meeting and exceeding financial goals. We believe that the right investment choices can inch you closer to your picture of success. To achieve this, our wins are hinged on yours to ensure that we meet and exceed your financial goals, together.";
        }else if (link === "pBanking"){
          headTitle = 'Prestige Banking';
          headText = "Creating solutions that work for you. Whatever your needs – be it the growth, management, or protection of wealth – we are on hand to provide expert advice that will inform your financial choices, while ensuring the final decision is always yours. From individuals to institutions, our Prestige Banking service is considered a valued partner. We take the time to get to know you and understand what’s important. No matter your needs, we are able to advise on the right solution and help make the most of the opportunities available.";
        }else if (link === "iBanking"){
          headTitle = 'Investment Banking';
          headText = "The Investment Banking team at FSDH Merchant Bank works with clients to understand their business needs and provide advisory and capital raising solutions that help foster growth. Our clients include corporations, financial institutions, high-net-worth individuals, and governmental institutions across the different sectors of the economy.";
        }else if (link === "cBanking"){
          headTitle = 'Corporate Banking';
          headText = "Helping you realise your business ambition. With access to the breadth of services across FSDH, we are able to navigate the complexities of the corporate world on your behalf, while you focus on growing your business. The FSDH Corporate Banking Group optimises the institutional knowledge resource base that the bank has built up, through its leading financial intermediary franchise over the past 27 years. We understand your unique banking needs and make it a point of duty to provide you with competitive and flexible banking services. Our Relationship Managers are committed to your long-term vision. Using their expertise, they have created bespoke financing solutions for a wide range of clients, across multiple industries, with varying business pressures. To ensure our Managers provide the best solution, we keep a finger on the financial pulse of the nation and play an active role in the corporate banking space. Due to the nature of the transactions we undertake, the funding of our Naira and foreign currency balance sheet is augmented with a robust base comprising; multiple foreign currency credit lines from well-known global correspondent banks, developmental financial institutions, multilateral agencies, and strategic partners.";
        } else if (link === "others"){
            headTitle = 'Others';
            headText = "";  
        } else {
            headText = "";  
        }

        return (
            <div className='service-full wealthmanagement'>
                <header className="banner" style={{backgroundImage: `url(${asset})`, }}>
                    <div className="container-fluid">
                        <div className='paginations'>
                            <div className="gray-button-sm">
                                <Link to='/'>Home</Link>
                            </div>
                            <div className="blue-button-sm">
                                <Link to='/productlist'>Products</Link>
                            </div>
                        </div>
                        <div className="header-text">
                            <h1 className='bold'>{headTitle}</h1>
                        </div>
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            <p>{headText}</p>
                        </div>
                    </div>
                </header>

                {/* TAB CONTROLS */}
                <div className="resources">
                    <div className="tab-container">
                        {link === "gMarkets" && <Nav tabs justified>
                            <NavItem active onClick={() => { this.setActive("gMarkets") }}>
                            <Link to="/productlist/gMarkets">Global Markets</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("cBanking") }} >
                            <Link to="/productlist/cBanking">Corporate Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("iBanking") }}>
                            <Link to="/productlist/iBanking">Investment Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("pBanking") }} >
                            <Link to="/productlist/pBanking">Prestige Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("others") }}>
                            <Link to="/productlist/others">Others</Link>
                            </NavItem>
                        </Nav>}  
                        {link === "cBanking" && <Nav tabs justified>
                        <NavItem onClick={() => { this.setActive("gMarkets") }}>
                            <Link to="/productlist/gMarkets">Global Markets</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("cBanking") }} >
                            <Link to="/productlist/cBanking">Corporate Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("iBanking") }}>
                            <Link to="/productlist/iBanking">Investment Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("pBanking") }} >
                            <Link to="/productlist/pBanking">Prestige Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("others") }}>
                            <Link to="/productlist/others">Others</Link>
                            </NavItem>
                        </Nav>}
                        {link === "iBanking" && <Nav tabs justified>
                        <NavItem onClick={() => { this.setActive("gMarkets") }}>
                            <Link to="/productlist/gMarkets">Global Markets</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("cBanking") }} >
                            <Link to="/productlist/cBanking">Corporate Banking</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("iBanking") }}>
                            <Link to="/productlist/iBanking">Investment Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("pBanking") }} >
                            <Link to="/productlist/pBanking">Prestige Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("others") }}>
                            <Link to="/productlist/others">Others</Link>
                            </NavItem>
                        </Nav>}
                        {link === "pBanking" && <Nav tabs justified>
                        <NavItem onClick={() => { this.setActive("gMarkets") }}>
                            <Link to="/productlist/gMarkets">Global Markets</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("cBanking") }} >
                            <Link to="/productlist/cBanking">Corporate Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("iBanking") }}>
                            <Link to="/productlist/iBanking">Investment Banking</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("pBanking") }} >
                            <Link to="/productlist/pBanking">Prestige Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("others") }}>
                            <Link to="/productlist/others">Others</Link>
                            </NavItem>
                        </Nav>}
                        {link === "others" && <Nav tabs justified>
                            <NavItem onClick={() => { this.setActive("gMarkets") }}>
                            <Link to="/productlist/gMarkets">Global Markets</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("cBanking") }} >
                            <Link to="/productlist/cBanking">Corporate Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("iBanking") }}>
                            <Link to="/productlist/iBanking">Investment Banking</Link>
                            </NavItem>
                            <NavItem onClick={() => { this.setActive("pBanking") }} >
                            <Link to="/productlist/pBanking">Prestige Banking</Link>
                            </NavItem>
                            <NavItem active onClick={() => { this.setActive("others") }}>
                            <Link to="/productlist/others">Others</Link>
                            </NavItem>
                        </Nav>}
                    </div>


                    {/* TAB CONTENTS */}
                    {link === "gMarkets" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/productlist/gMarkets/fIncome' tagName="products" ServiceName="Fixed Income Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/gMarkets/fExchange' tagName="products" ServiceName="Foreign Exchange Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/gMarkets/iRate' tagName="products" ServiceName="Interest Rate Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/gMarkets/tSales' tagName="products" ServiceName="Treasury Sales" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}

                    {link === "cBanking" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/productlist/cBanking/lServices' tagName="products" ServiceName="Lending Services" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/bandg' tagName="products" ServiceName="Bonds &amp; Guarantees" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/sTrade' tagName="products" ServiceName="Structured Trade Finance" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/dSolutions' tagName="products" ServiceName="Digital Solutions and Collections" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/tBanking' tagName="products" ServiceName="Transactional Banking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/aBanking' tagName="products" ServiceName="Agency Banking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/pReceipts' tagName="products" ServiceName="Processing Payments &amp; Receipts" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/cBanking/bCoverage' tagName="products" ServiceName="Business Coverage" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}

                    {link === "iBanking" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/productlist/iBanking/eCapital' tagName="products" ServiceName="Equity Capital Markets" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/iBanking/dCapital' tagName="products" ServiceName="Debt Capital Markets" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/iBanking/fAdvisory' tagName="products" ServiceName="Financial Advisory &amp; Mergers and Acquisitions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                {/* <CardTwoOutine nLink='/productlist/iBanking/ma' tagName="products" ServiceName="Mergers and Acquisitions (M&#38;A)" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" /> */}
                                <CardTwoOutine nLink='/productlist/iBanking/pFinance' tagName="products" ServiceName="Project Finance" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/iBanking/sFinance' tagName="products" ServiceName="Structured Finance" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}
                    
                    {link === "pBanking" && <div className="container-fluid tab-content section-alt">
                    {        
                        
                        <div className="home">
                            <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem', color:'black' }}>INDIVIDUALS<i className={"fa fa-chevron-down"} aria-hidden="true" id='faInd'></i></Button>
                            <Collapse isOpen={this.state.collapse}>
                                {/* <Card> */}
                                    {/* <CardBody> */}
                                        <div className='row'>
                                            <CardTwoOutine nLink='/productlist/pBanking/wPreservation' tagName="products / INDIVIDUALS" ServiceName="Wealth Preservation" ButtonText="Learn more" BgColor="dark-blue-bg"
                                            ServiceDesc="" />
                                            <CardTwoOutine nLink='/productlist/pBanking/bWealth' tagName="products / INDIVIDUALS" ServiceName="Bespoke Wealth Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                            ServiceDesc="" />
                                            <CardTwoOutine nLink='/productlist/pBanking/wPortfolio' tagName="products / INDIVIDUALS" ServiceName="Wealth Portfolio Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                                            ServiceDesc="" />
                                        </div>
                                    {/* </CardBody> */}
                                {/* </Card> */}
                            </Collapse>
                            <br />
                            <Button className='collapseBTN' color="link" onClick={this.toggleTwo} style={{ marginBottom: '1rem', color:'black' }}>INSTITUTIONAL<i className={"fa fa-chevron-down"} aria-hidden="true" id='faIns'></i></Button>
                            <Collapse isOpen={this.state.collapseTwo}>
                                {/* <Card>
                                    <CardBody> */}
                                        <div className='row'>
                                            <CardTwoOutine nLink='/productlist/pBanking/investments' tagName="products / INSTITUTIONAL" ServiceName="Investments" ButtonText="Learn more" BgColor="dark-blue-bg"
                                            ServiceDesc="" />
                                            <CardTwoOutine nLink='/productlist/pBanking/iPortfolio' tagName="products / INSTITUTIONAL" ServiceName="Institutional Portfolio Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                                            ServiceDesc="" />
                                            <CardTwoOutine nLink='/productlist/pBanking/lManagement' tagName="products / INSTITUTIONAL" ServiceName="Liquidity Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                                            ServiceDesc="" />
                                        </div>
                                    {/* </CardBody>
                                </Card> */}
                            </Collapse>
                        </div>

                        // <div className="home">
                        //     <div className="row">
                        //         <CardTwoOutine nLink='/productlist/pBanking/wPreservation' tagName="products / INDIVIDUALS" ServiceName="Wealth Preservation" ButtonText="Learn more" BgColor="dark-blue-bg"
                        //         ServiceDesc="" />
                        //         <CardTwoOutine nLink='/productlist/pBanking/bWealth' tagName="products / INDIVIDUALS" ServiceName="Bespoke Wealth Solutions" ButtonText="Learn more" BgColor="dark-blue-bg"
                        //         ServiceDesc="" />
                        //         <CardTwoOutine nLink='/productlist/pBanking/wPortfolio' tagName="products / INDIVIDUALS" ServiceName="Wealth Portfolio Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                        //         ServiceDesc="" />
                        //         <CardTwoOutine nLink='/productlist/pBanking/investments' tagName="products / INSTITUTIONAL" ServiceName="Investments" ButtonText="Learn more" BgColor="dark-blue-bg"
                        //         ServiceDesc="" />
                        //         <CardTwoOutine nLink='/productlist/pBanking/iPortfolio' tagName="products / INSTITUTIONAL" ServiceName="Institutional Portfolio Advisory" ButtonText="Learn more" BgColor="dark-blue-bg"
                        //         ServiceDesc="" />
                        //         <CardTwoOutine nLink='/productlist/pBanking/lManagement' tagName="products / INSTITUTIONAL" ServiceName="Liquidity Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                        //         ServiceDesc="" />
                        //     </div>
                        // </div>
                    }
                    </div>}

                    {link === "others" && <div className="container-fluid tab-content section-alt">
                    {                    
                        <div className="home">
                            <div className="row">
                                <CardTwoOutine nLink='/productlist/others/aManagement' tagName="products" ServiceName="Asset Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/others/stockbroking' tagName="products" ServiceName="Stockbroking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/others/pensions' tagName="products" ServiceName="Pensions" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                                <CardTwoOutine nLink='/productlist/others/cCoverage' tagName="products" ServiceName="Business Coverage" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="" />
                            </div>
                        </div>
                    }
                    </div>}
                </div>

                {/* <div className="details"> */}
                    {/* <div className="container-fluid">
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            <p>
                                At FSDH Merchant Bank, we listen to our clients to establish their financial goals,
                                then partner with them to develop bespoke wealth and investment management strategies,
                                as well as identify viable investment opportunities to help preserve and grow their wealth.
                            </p>
                        </div>
                    </div> */}
                    {/* <div className="section-alt home">
                        <div className="container-fluid">
                            <div className="row">
                                <CardTwoOutine nLink='/' tagName="products" ServiceName="Global Markets" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="products" ServiceName="Corporate Banking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="products" ServiceName="Investment Banking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="products" ServiceName="Prestige Banking" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                                <CardTwoOutine nLink='/' tagName="products" ServiceName="Others" ButtonText="Learn more" BgColor="dark-blue-bg"
                                ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                            </div>
                        </div>
                    </div> */}
                {/* </div> */}

                {/* RELATED FEATURES */}
                {/* <div className="section-alt">
                    <div className="container-fluid">
                        <div className="row">
                            <StyleOne tag='services' serviceDesc='Investment Banking' bgcolor='dark-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                            <StyleOne tag='services' serviceDesc='Corporate Banking' bgcolor='light-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                        </div>
                    </div>
                </div> */}
            </div>
        );
    }
}

export default ProductList;